import { gql } from '@apollo/client';

export const USERS_GET_BY_ID = gql`
  query UsersGetById($id: String!, $login: Boolean!) {
    usersGetById(id: $id, login: $login) {
      code
      user {
        dateAdded
        id
        email
        verified
        firstName
        lastName
        zipCode
        lastLogin
        favorites {
          id
          dateAdded
        }
        savedSearches {
          id
          name
          searchParams
          dateAdded
        }
      }
    }
  }
`;
